module.exports = __webpack_public_path__ + "img/template_public_icon.a285543e.svg";